module.exports = __webpack_public_path__ + "img/ZWF_Lunch_Saturday.60bf70ef.jpg";